var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"title":_vm.title},on:{"click":_vm.switchActive}},[_c('UiBaseIcon',{attrs:{"width":"24px","height":"24px","color":_vm.color,"icon-name":"unplugged"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }